const fuelStations = {
  FUEL_STATIONS: '/app/fuelstations',
}

const summary = {
  SUMMARY: 'summary',
  SUMMARY_PATH: `${fuelStations.FUEL_STATIONS}/summary`,
}

const margin = {
  MARGIN: 'margin',
  MARGIN_PATH: `${fuelStations.FUEL_STATIONS}/margin`,
}

const notificationsFuelStations = {
  // TODO: Remove following line
  NOTIFICATIONS: 'notifications',
  NOTIFICATIONS_PATH: `${fuelStations.FUEL_STATIONS}/notifications`,
}

const spainFuelStations = {
  // TODO: Remove following line
  SPAIN: 'spain',
  SPAIN_PATH: `${fuelStations.FUEL_STATIONS}/spain`,
}

const favoritesFuelStations = {
  // TODO: Remove following line
  FAVORITES: 'favorites',
  FAVORITES_PATH: `${fuelStations.FUEL_STATIONS}/favorites`,
}

const ownsFuelStations = {
  // TODO: Remove following line
  OWNS: 'owns',
  OWNS_PATH: `${fuelStations.FUEL_STATIONS}/owns`,
}
const pricesFuelStations = {
  // TODO: Remove following line
  PRICE_CHANGES: 'price_changes',
  PRICE_CHANGES_PATH: `${fuelStations.FUEL_STATIONS}/price_changes`,
}

const tanksFuelStations = {
  // TODO: Remove following line
  TANKS: 'tanks',
  TANKS_PATH: `${fuelStations.FUEL_STATIONS}/tanks`,
}

const ownFuelStation = {
  DATA: (id) =>
    fuelStations.FUEL_STATIONS + '/' + ownsFuelStations.OWNS + `/${id}/data`,
  COMPETENCES: (id) =>
    fuelStations.FUEL_STATIONS +
    '/' +
    ownsFuelStations.OWNS +
    `/${id}/competences`,
  PRICES: (id) =>
    fuelStations.FUEL_STATIONS + '/' + ownsFuelStations.OWNS + `/${id}/prices`,
  PURCHASE_PRICES: (id) =>
    fuelStations.FUEL_STATIONS +
    '/' +
    ownsFuelStations.OWNS +
    `/${id}/purchase_prices`,
  MARGIN: (id) =>
    fuelStations.FUEL_STATIONS + '/' + ownsFuelStations.OWNS + `/${id}/margin`,
  STOCK: (id) =>
    fuelStations.FUEL_STATIONS + '/' + ownsFuelStations.OWNS + `/${id}/stok`,
  TANKS: (id) =>
    fuelStations.FUEL_STATIONS + '/' + ownsFuelStations.OWNS + `/${id}/tanks`,
  CONSUMPTION_PREVENTION: (id) =>
    fuelStations.FUEL_STATIONS +
    '/' +
    ownsFuelStations.OWNS +
    `/${id}/consumptionsPrevention`,
}

export {
  summary,
  margin,
  fuelStations,
  notificationsFuelStations,
  spainFuelStations,
  favoritesFuelStations,
  ownsFuelStations,
  ownFuelStation,
  pricesFuelStations,
  tanksFuelStations,
}
